import { lazy } from 'react';

const IncomingView = lazy(() => import('./IncomingView'));

export default IncomingView;
